var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPinIcon = function SvgPinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currnetColor",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pin-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.022 5.383c0-1.067.854-1.987 2-2h7a2 2 0 0 1 0 4h-.5v4.174c2.334 1.075 4.015 3.599 4 6.326a.503.503 0 0 1-.5.5h-6v4.5a.5.5 0 0 1-1 0v-4.5h-6a.495.495 0 0 1-.5-.5c0-2.675 1.554-5.186 4-6.326V7.383h-.5a2 2 0 0 1-2-2Zm2-1a1 1 0 0 0 0 2h1c.255 0 .5.209.5.5v4.998a.5.5 0 0 1-.307.462c-1.963.818-3.479 2.664-3.672 5.04h11.958c-.163-2.241-1.751-4.272-3.67-5.04a.503.503 0 0 1-.31-.46l.002-5a.5.5 0 0 1 .5-.5h1a1 1 0 1 0 0-2h-7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pin-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.596 0h24v24h-24z"
  })))));
};
export default SvgPinIcon;